import { defineStore } from 'pinia'
import { ref, computed } from 'vue'
import axios from 'axios'
import httpRequest from '@/utils/httpRequest'

export const useUserStore = defineStore('user', () => {
  const token = ref(localStorage.getItem('token') || '')
  const userInfo = ref(null)

  const isLoggedIn = computed(() => !!token.value)

  // 登录
  const login = async (data) => {
    try {
      const res = await axios.post(`${process.env.VUE_APP_API_URL}/auth/login`, data, {
        withCredentials: true,
        credentials: 'include'
      })
      console.log('登录请求响应:', res)

      // 检查响应中的错误码
      if (res.data.code === 500) {
        throw new Error(res.data.msg || '登录失败')
      }

      // 成功时，从 res.data.data 中获取 token
      if (res.data.code === 200) {
        console.log('登录成功:', res.data)
        // 修改这里：使用 res.data.data 获取 token
        token.value = res.data.data
        localStorage.setItem('token', res.data.data)
        await getUserInfo()
      } else {
        throw new Error(res.data.msg || '登录失败')
      }
    } catch (error) {
      if (error.response?.data) {
        throw new Error(error.response.data.msg || '登录失败')
      }
      console.error('登录失败:', error)
      throw error
    }
  }

  // 手机号登录
  const loginByPhone = async (data) => {
    const res = await axios.post('/api/login/phone', data)
    token.value = res.data.token
    localStorage.setItem('token', res.data.token)
    await getUserInfo()
  }

  // 注册
// 注册
const register = async (data) => {
  try {
    const res = await axios.post(`${process.env.VUE_APP_API_URL}/auth/register`, data, {
      withCredentials: true,
      credentials: 'include' // 添加这个配置允许跨域请求时发送 cookies
    })
    // 检查响应中的错误码
    if (res.data.code === 500) {
      throw new Error(res.data.msg || '注册失败')
    }
    return res.data
  } catch (error) {
    // 处理 axios 错误响应
    if (error.response?.data) {
      throw new Error(error.response.data.msg || '注册失败')
    }
    // 处理其他错误
    console.error('注册失败:', error)
    throw error
  }
}

  // 发送短信验证码
  const sendSmsCode = async (phone) => {
    await axios.post('/api/sms/send', { phone })
  }

  // 获取用户信息
  const getUserInfo = async () => {
    try{
      if (!token.value) return null
      const res = await httpRequest.get('/user/info')
      if (res.code === 200) {
        userInfo.value = res.data || null
        return userInfo.value
      } else {
        throw new Error(res.msg || '获取用户信息失败')
      }
    } catch (error) {
      userInfo.value = null
      console.error('获取用户信息失败:', error)
      return null
    }
  }

  // 退出登录
  const logout = () => {
    token.value = ''
    userInfo.value = null
    localStorage.removeItem('token')
  }
  const updateUserInfo = async (data) => {
    try {
      const res = await httpRequest.post('/user/updateUserInfo', data)
      if (res.code !== 200) {
        throw new Error(res.msg || '更新失败')
      }
      userInfo.value = res.data
      return res.data
    } catch (error) {
      console.error('更新用户信息失败:', error)
      throw new Error(error.response?.data?.msg || error.message || '更新失败')
    }
  }
  const updatePassword = async (passwordData) => {
    try {
      console.log('passwordData:', passwordData)
      const response = await httpRequest.post('/user/updatePassword', passwordData)
      if (response.code !== 200) {
        throw new Error(response.msg || '更新密码失败')
      }
      return response.data
    } catch (error) {
      throw error
    }
  }

  // 重新生成API密钥
  const regenerateApiKey = async () => {
    try {
      const res = await httpRequest.post('/user/regenerateApiKey')
      if (res.code !== 200) {
        throw new Error(res.msg || '生成失败')
      }
      // 更新用户信息中的API密钥
      if (userInfo.value) {
        userInfo.value.apiKey = res.data.apiKey
      }
      return res.data
    } catch (error) {
      console.error('重新生成API密钥失败:', error)
      throw new Error(error.response?.data?.msg || error.message || '生成失败')
    }
  }

  // 获取OSS上传签名
  const getOssPolicy = async () => {
    try {
      const res = await httpRequest.get('/oss/policy')
      if (res.code === 200) {
        return res.data
      } else {
        throw new Error(res.msg || '获取上传配置失败')
      }
    } catch (error) {
      console.error('获取上传配置失败:', error)
      throw error
    }
  }
// 获取动态列表
  const fetchPosts = async (params) => {
    try {
      const res = await httpRequest.get('/community/posts', params)
      if (res.code === 200) {
        return res.data
      } else {
        throw new Error(res.msg || '获取动态列表失败')
      }
    } catch (error) {
      console.error('获取动态列表失败:', error)
      throw new Error(error.response?.data?.msg || error.message || '获取动态列表失败')
    }
  }

  // 发布新动态
  const createPost = async (postData) => {
    try {
      console.log('store中的postData:', postData)
      
      // 直接发送JSON数据，不需要FormData转换
      const res = await httpRequest.post('/community/posts', postData)
      
      if (res.code === 200) {
        return res.data
      } else {
        throw new Error(res.msg || '发布失败')
      }
    } catch (error) {
      console.error('发布动态失败:', error)
      throw new Error(error.response?.data?.msg || error.message || '发布失败')
    }
  }

  // 点赞/取消点赞
  const toggleLike = async (postId) => {
    try {
      const res = await httpRequest.post(`/community/posts/${postId}/like`)
      if (res.code === 200) {
        return res.data
      } else {
        throw new Error(res.msg || '操作失败')
      }
    } catch (error) {
      console.error('点赞操作失败:', error)
      throw new Error(error.response?.data?.msg || error.message || '操作失败')
    }
  }

  // 发表评论
  const createComment = async (postId, content) => {
    try {
      const res = await httpRequest.post(`/community/posts/${postId}/comments`, { content })
      if (res.code === 200) {
        return res.data
      } else {
        throw new Error(res.msg || '评论失败')
      }
    } catch (error) {
      console.error('发表评论失败:', error)
      throw new Error(error.response?.data?.msg || error.message || '评论失败')
    }
  }
  return {
    token,
    userInfo,
    isLoggedIn,
    login,
    loginByPhone,
    register,
    sendSmsCode,
    getUserInfo,
    logout,
    updateUserInfo,
    updatePassword,
    regenerateApiKey,
    getOssPolicy,
    fetchPosts,
    createPost,
    toggleLike,
    createComment
  }
})
